import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useBreadcrumb } from "../../../context/breadcrumb";
import { BreadcrumbActionType } from "../../../context/breadcrumb/reducer";
import VuiHelmet from "../../../components/helmet";
import ShortLinkListModule from "../../../modules/short-link/list";

const ShortLinksListPage = () => {
  const { t } = useTranslation();
  const { dispatch } = useBreadcrumb();

  useEffect(() => {
    dispatch({
      type: BreadcrumbActionType.Update,
      payload: [
        {
          link: "/",
          title: t("common.text.tools"),
        },
        {
          link: "/short-link",
          title: t("common.text.shortLinks"),
          isDisabled: true,
        },
      ],
    });
  }, [dispatch, t]);

  return (
    <>
      <VuiHelmet title={t("pages.shortLink.list.metaTitle")} />

      <ShortLinkListModule />
    </>
  );
};

export default ShortLinksListPage;
